<script>
/* eslint-disable vue/prop-name-casing */
import Questionnaire from '@/components/UI/QuestionnaireQQ.vue';

export default {
  components: {
    Questionnaire
  },
  props: {
    RuleVerificationTextProp: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      RuleVerificationText: {
        type: String,
        default() {
          return '';
        }
      },
      currentStep: 1,
      verificationIssues: [],
      blockedQuestions: []
    };
  },
  mounted() {
    this.RuleVerificationText = this.RuleVerificationTextProp;    
  },
  methods: {
    updateActiveVerificationIssues(verificationIssues) {
      this.verificationIssues = verificationIssues;
    },
    updateActiveStep(step) {
      this.currentStep = step;
    },
    verifyBlockingRules() {
      for (var i = 0; i < this.verificationIssues.length; i++) {
        var issue = this.verificationIssues[i];
        if (issue.Step === this.currentStep && issue.RuleType == 0) {
          this.RuleVerificationText = issue.Text;
          this.showQuickQuoteModalVerificationIssue();
          return true;
        }
      }

      return false;
    },
    onQuestionnaireChanged(param) {
      // Remove question as blocked
      var index = this.blockedQuestions.indexOf(param.questionId);
      if (index > -1) {
        this.blockedQuestions.splice(index, 1);
      }

      for (var i = 0; i < this.verificationIssues.length; i++) {
        var issue = this.verificationIssues[i];

        // Verify that we are on correct step and rule type is blocking + questionnaire
        if (issue.Step != this.currentStep || issue.RuleType != 0 || issue.Type != 2) {
          continue;
        }

        if (issue.QuestionId == param.questionId && issue.AnswerId == param.answer.Id) {
          // add question as blocked
          this.blockedQuestions.append(param.questionId);

          this.RuleVerificationText = issue.Text;
          this.showQuickQuoteModalVerificationIssue();
        }
      }

      // If no blocking issues are present - then enable button
      if (this.blockedQuestions.length > 0) {
        this.$emit('disable-next-button', true);
      } else {
        this.$emit('disable-next-button', false);
      }
    }
  }
};
</script>
